var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"barcodes-wrapper"},_vm._l((_vm.spots),function(spot){return _c('VueBarcode',{key:spot.id,staticClass:"barcode-item",attrs:{"value":spot.barcode,"element-tag":'img',"font":'Roboto',"margin":30}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }